"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _sortablejs = _interopRequireDefault(require("sortablejs"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useDraggableTable = function useDraggableTable(_ref) {
  var elementRef = _ref.elementRef,
      draggable = _ref.draggable,
      setData = _ref.setData,
      disableReorder = _ref.disableReorder,
      state = _ref.state;

  var _useState = (0, _react.useState)(null),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sortable = _useState2[0],
      setSortable = _useState2[1];

  var noReorder = (0, _react.useMemo)( // Can't reorder when the table is sorted,
  // disableReorder is set to true
  // or is searching
  function () {
    return state.sortBy.length || disableReorder || !!state.globalFilter || state.filters.length;
  }, [state.sortBy, disableReorder, state.globalFilter, state.filters]);
  var handleUpdate = (0, _react.useCallback)(function (e) {
    var oldIndex = e.oldIndex,
        newIndex = e.newIndex; // Set reorder data

    setData(function (previousList) {
      if (!previousList || !previousList.length) return [];
      var targetItem = previousList[oldIndex];
      var oldList = (0, _toConsumableArray2["default"])(previousList);
      oldList.splice(oldIndex, 1);
      var newList = (0, _toConsumableArray2["default"])(oldList);
      newList.splice(newIndex, 0, _objectSpread({}, targetItem));
      return newList;
    });
  }, [setData]);
  (0, _react.useEffect)(function () {
    if (draggable !== true || sortable) return;
    var el = elementRef.current; // Create sortable rows

    var sortableInstance = _sortablejs["default"].create(el, {
      handle: '.reorder-handle',
      animation: 150,
      onUpdate: handleUpdate
    });

    setSortable(sortableInstance);
  }, [draggable, elementRef, handleUpdate, sortable]);
  (0, _react.useEffect)(function () {
    if (!sortable) return;
    sortable.option('disabled', noReorder);
  }, [sortable, noReorder]);
  return {
    noReorder: noReorder
  };
};

var _default = useDraggableTable;
exports["default"] = _default;
//# sourceMappingURL=useDraggableTable.js.map